import React, {createContext, useState, useRef} from 'react';

export const MadricContext = createContext();

/**
 * Le context
 * @param {*} props props
 * @return {JSX}
 */
export default function MadricContextProvider(props) {
  const [connUser, setConnUser] = useState({id: '', name: '', email: '', is_admin: 0});
  const [whatToShow, setWhatToShow] = useState('1');

  const [whatToShowGlobal, setWhatToShowGlobal] = useState('1');

  const [projectInfo, setProjectInfo] = useState([]);
  const [idProjectInfo, setIdProjectInfo] = useState(null);
  const projectInfoObtained = useRef([]);

  const [listeEmploye, setListeEmploye] = useState([]);
  const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 });

  const [activeLink, setActiveLink] = useState('accueil');

  const filterFormGlobal = useRef({
    name: {label: 'Filtrer par nom'},
    dateDebut: '',
    dateFin: '',
    extra1: false,
    extra2: false,
    extra3: false, 
  });

  const filterForm = useRef({
    toComplete: false,
    toNonComplete: false,

    chNote: '',
    chTransport: false,

    phNote: '',
    phAvancement: false,

    faNomFacture: [],
    faNote: '',
    faAvancement: false,

    pdNote: '',
    pdPermission: false,

    noNote: '',
  });

  const selectedOptions = useRef([]);


  const allowedContent = {
    connUser,
    setConnUser,
    projectInfo, 
    setProjectInfo,
    idProjectInfo,
    setIdProjectInfo,
    projectInfoObtained,
    whatToShow,
    setWhatToShow,
    listeEmploye,
    setListeEmploye,
    scrollPosition,
    setScrollPosition,
    filterFormGlobal,
    filterForm,
    selectedOptions,
    whatToShowGlobal,
    setWhatToShowGlobal,
    activeLink,
    setActiveLink
  };

  return (
    <MadricContext.Provider value ={allowedContent}>
      {props.children}
    </MadricContext.Provider>
  );
}
